import React from "react";

import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import { Box, Tooltip } from "@mui/material";

import { Colors } from "../../../../../config/styles";
import useBus from "../../context";

import { BusScheduleTimesInfoType } from "../../../../../types/bus";

import { StyledTableBody } from "./styles";

interface ComponentProps {
  scheduleBus: BusScheduleTimesInfoType;
  busId: string;
  showFullHour?: boolean;
}

export default function DepartTable({ scheduleBus, busId, showFullHour = false }: ComponentProps) {
  const { currentClock, nextBuses, CUSTOM_NOW } = useBus();

  React.useEffect(() => {}, [currentClock]);

  return (
    <table style={{ width: "100%", fontFamily: "nunito", fontSize: 14 }}>
      <StyledTableBody>
        {!!Object.keys(scheduleBus ?? {}) &&
          Object.keys(scheduleBus).map((hour, index) => {
            return (
              <tr key={`hour-${hour}-${index}`}>
                {Object.keys(scheduleBus[hour]).map((minute, minuteIndex) => {
                  const itHourValue = `0${hour}`.slice(-2);
                  const itMinuteValue = `0${minute}`.slice(-2);
                  const itTime = `${itHourValue}:${itMinuteValue}`;

                  let diffTimeColor: string | undefined = undefined;

                  if (nextBuses[busId]?.next && nextBuses[busId].next === itTime) {
                    const nextBusDateObj = CUSTOM_NOW()
                      .set({ hour: parseInt(String(nextBuses[busId].next).split(":")[0]) })
                      .set({ minute: parseInt(String(nextBuses[busId].next).split(":")[1]) });

                    const itTimeDateObj = CUSTOM_NOW()
                      .set({ hour: parseInt(itTime.split(":")[0]) })
                      .set({ minute: parseInt(itTime.split(":")[1]) });

                    const actualDiff = itTimeDateObj.diff(nextBusDateObj, "minutes");

                    if (actualDiff.minutes < 3) diffTimeColor = Colors.BusRed;
                    else if (actualDiff.minutes < 6) diffTimeColor = Colors.BusOrange;
                    else diffTimeColor = Colors.BusGreen;
                  }

                  const element = (
                    <td
                      style={{
                        textAlign: "center",
                        height: 45,
                        flex: minuteIndex === 0 ? 2 : 1,
                        borderRadius: 15,
                      }}
                      key={`row-${minute}-${index}`}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: 15,
                          height: "80%",
                          backgroundColor:
                            nextBuses[busId]?.next === itTime ? diffTimeColor : undefined,
                        }}
                      >
                        {`${
                          showFullHour || minuteIndex === 0 ? `0${hour}`.slice(-2) : ""
                        }:${`0${minute}`.slice(-2)}`}

                        {scheduleBus[hour][minute]?.ru ? (
                          <RestaurantIcon
                            style={{
                              fontSize: "inherit",
                              marginBottom: -2,
                              marginLeft: 3,
                              width: 14,
                              color: "rgba(255,255,255,0.5)",
                            }}
                          />
                        ) : null}

                        {scheduleBus[hour][minute]?.terminal ? (
                          <DirectionsBusIcon
                            style={{
                              fontSize: "inherit",
                              marginBottom: -2,
                              marginLeft: 3,
                              width: 14,
                              color: "rgba(255,255,255,0.5)",
                            }}
                          />
                        ) : null}

                        {showFullHour ? null : scheduleBus[hour][minute]?.ru ||
                          scheduleBus[hour][minute]?.terminal ? null : (
                          <Box style={{ width: 17 }} />
                        )}
                      </div>
                    </td>
                  );

                  if ("company" in scheduleBus[hour][minute]) {
                    return (
                      <Tooltip
                        key={`tip-${minute}-${index}`}
                        title={scheduleBus[hour][minute].company}
                        placement="top"
                        arrow
                      >
                        {element}
                      </Tooltip>
                    );
                  } else if (scheduleBus[hour][minute]?.ru) {
                    return (
                      <Tooltip
                        key={`tip-${minute}-${index}`}
                        title={"Indo para o RU"}
                        placement="top"
                        arrow
                      >
                        {element}
                      </Tooltip>
                    );
                  } else if (scheduleBus[hour][minute]?.terminal) {
                    return (
                      <Tooltip
                        key={`tip-${minute}-${index}`}
                        title={"Saindo do terminal RU"}
                        placement="top"
                        arrow
                      >
                        {element}
                      </Tooltip>
                    );
                  } else {
                    return element;
                  }
                })}
              </tr>
            );
          })}
      </StyledTableBody>
    </table>
  );
}
